module.exports = __webpack_public_path__ + "img/bank-icon.8a4fa3f9.svg";